import React from 'react';
import { Typography } from 'ui-kit';
import ConfirmModal from 'components/ConfirmModal/ConfirmModal';
import './styles.scss';

const SecondConfirmModalMassDeleteProduct = ({
  isOpen,
  onConfirm,
  onCancel,
}: {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) => (
  <ConfirmModal
    className="ConfirmPropagateModal"
    visible={isOpen}
    onConfirm={onConfirm}
    onCancel={onCancel}
    confirmText="Delete All"
    cancelText="Cancel"
    confirmBtnType="error"
    destroyOnClose
  >
    <Typography className="ConfirmPropagateModal_title" variant="h6">
      Are you sure you want to proceed?
    </Typography>
    <p>This will delete ALL tiles for this product that were created together as a single set.</p>
    <p>ONCE DELETED THESE TILES CANNOT BE RECOVERED.</p>
  </ConfirmModal>
);

export default SecondConfirmModalMassDeleteProduct;
